import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const InquiryPopup = ({ onClose }) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [inputData, setInputData] = useState({
    fullName: "",
    emailID: "",
    contactNumber: "",
    userMessage: "",
  });
  const [phoneError, setPhoneError] = useState("");

  const navigate = useNavigate();

  const handleClose = () => {
    onClose();
    navigate("/");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "contactNumber") {
      if (/^\d{0,10}$/.test(value)) {
        setPhoneError("");
        setInputData({ ...inputData, contactNumber: value });
      } else {
        setPhoneError("Please enter only 10 digits.");
      }
    } else {
      setInputData({ ...inputData, [name]: value });
    }
  };

  // ⭐ FINAL WORKING SUBMIT FUNCTION (Correct)
  const submitInquiry = async (e) => {
  e.preventDefault();

  if (phoneError || inputData.contactNumber.length !== 10) {
    setPhoneError("Phone number must be exactly 10 digits.");
    return;
  }

  const formData = new FormData();
  formData.append("Full Name", inputData.fullName);
  formData.append("Email", inputData.emailID);
  formData.append("Phone", inputData.contactNumber);
  formData.append("Course", selectedCourse);
  formData.append("Message", inputData.userMessage);

  try {
    const res = await fetch("https://formspree.io/f/mrbjpajb", {
      method: "POST",
      body: formData,
      headers: { Accept: "application/json" },
    });

    if (res.ok) {
      setIsSubmitted(true);
      setTimeout(handleClose, 2500);
    } else {
      alert("Error submitting form");
    }
  } catch (err) {
    alert("Network Error!");
  }
};


  return (
    <>
      <div className="custom-overlay" onClick={handleClose}>
        <div
          className="custom-box fade-in"
          onClick={(e) => e.stopPropagation()}
        >
          <button className="custom-close-btn" onClick={handleClose}>
            ×
          </button>

          {!isSubmitted ? (
            <>
              <h2 className="custom-title">Inquiry Form</h2>
              <form className="custom-form" onSubmit={submitInquiry}>
                <input
                  type="text"
                  name="fullName"
                  placeholder="Full Name"
                  onChange={handleInputChange}
                  required
                />

                <input
                  type="email"
                  name="emailID"
                  placeholder="Email Address"
                  onChange={handleInputChange}
                  required
                />

                <input
                  type="tel"
                  name="contactNumber"
                  maxLength="10"
                  value={inputData.contactNumber}
                  onChange={handleInputChange}
                  placeholder="Phone Number"
                  required
                />
                {phoneError && <p className="error">{phoneError}</p>}

                <div className="custom-radio-group">
                  {["Ethical Hacking", "Cyber Security", "CCNA", "CompTIA"].map(
                    (course) => (
                      <label key={course} className="custom-radio">
                        <input
                          type="radio"
                          value={course}
                          checked={selectedCourse === course}
                          onChange={(e) => setSelectedCourse(e.target.value)}
                          required
                        />
                        <span>{course}</span>
                      </label>
                    )
                  )}
                </div>

                <textarea
                  name="userMessage"
                  placeholder="Your Message"
                  rows="3"
                  onChange={handleInputChange}
                  required
                ></textarea>

                <button type="submit" className="custom-submit-btn">
                  Submit
                </button>
              </form>
            </>
          ) : (
            <div className="custom-thankyou">
              <h3>Thank You!</h3>
              <p>Your inquiry has been successfully submitted.</p>
            </div>
          )}
        </div>
      </div>

      {/* ————————————— STYLE ————————————— */}
      <style>{`
        .custom-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.55);
          backdrop-filter: blur(4px);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 2000;
        }
        .custom-box {
          width: 90%;
          max-width: 450px;
          background: rgba(243, 236, 236, 0.2);
          backdrop-filter: blur(14px);
          padding: 30px;
          border-radius: 16px;
          border: 1px solid rgba(255,255,255,0.25);
          box-shadow: 0px 10px 30px rgba(0,0,0,0.25);
          position: relative;
        }
        .fade-in {
          animation: fadeInScale 0.3s ease-out;
        }
        @keyframes fadeInScale {
          from { opacity: 0; transform: scale(0.85); }
          to { opacity: 1; transform: scale(1); }
        }
        .custom-close-btn {
          position: absolute;
          right: 14px;
          top: 12px;
          background: transparent;
          border: none;
          font-size: 28px;
          color: white;
          cursor: pointer;
        }
        .custom-title {
          text-align: center;
          color: #fff;
          font-size: 24px;
          font-weight: 700;
          margin-bottom: 20px;
        }
        .custom-form input,
        .custom-form textarea {
          width: 80%;
          padding: 15px;
          margin-bottom: 16px;
          border-radius: 10px;
          border: none;
          outline: none;
          font-size: 16px;
          background: #fff;
          color: #000;
        }
        .custom-radio-group {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
          margin-bottom: 16px;
        }
        .custom-radio {
          display: flex;
          align-items: center;
          gap: 10px;
          background: rgba(255,255,255,0.3);
          padding: 10px 12px;
          border-radius: 10px;
          cursor: pointer;
          color: white;
          font-weight: 600;
          transition: 0.3s;
        }
        .custom-radio input {
          accent-color: #6b1e6e;
          width: 18px;
          height: 18px;
        }
        .custom-submit-btn {
          width: 100%;
          padding: 14px;
          background: #742173;
          color: white;
          border: none;
          border-radius: 10px;
          font-size: 18px;
          cursor: pointer;
          font-weight: 600;
          transition: 0.3s;
        }
        .custom-submit-btn:hover {
          background: #581357;
        }
        .custom-thankyou {
          text-align: center;
          color: white;
          font-size: 20px;
        }
        .error {
          color: #ff4d4d;
          font-size: 14px;
          margin-top: -10px;
          margin-bottom: 12px;
        }
      `}</style>
    </>
  );
};

export default InquiryPopup;
